<template>
    <div>
        <b-modal
            id="change-password-popup"
            ref="modal"
            title="Change Password"
            size="sm"
            hide-footer
            no-close-on-backdrop
            :hide-header-close="loading"
            no-close-on-esc
            modal-class="hide-footer"
            @hidden="hideModal()"
            @shown="showModal()"
        >
            <b-form @submit.stop.prevent="onSubmit()" @reset="hideModal">
                <div class="row custom-model-form">
                    <div class="col-md-12">
                        <b-form-group
                            id="old-password-input"
                            label="Old Password"
                            label-for="old-password"
                        >
                            <b-form-input
                                id="old-password-field"
                                v-model="formData.oldPassword"
                                v-validate="{
                                    required: true,
                                    max: 20,
                                    min: 6,
                                    regex: /^(?=^.{6,20}$)(?=.*\d)(?=.*[a-z])(?=.*[A-Z])(?=.*[!@#$%^&amp;*_=+-])(?!.*\s).*$/,
                                }"
                                type="password"
                                placeholder="Enter old password"
                                data-vv-name="old password"
                                :class="{
                                    'is-invalid': errors.has('old password'),
                                }"
                            ></b-form-input>
                        </b-form-group>
                    </div>
                    <div class="col-md-12">
                        <b-form-group
                            id="new-password-input"
                            label="New Password"
                            label-for="new-password"
                        >
                            <b-form-input
                                id="new-password-field"
                                ref="password"
                                v-model="formData.password"
                                v-validate="{
                                    required: true,
                                    max: 20,
                                    min: 6,
                                    regex: /^(?=^.{6,20}$)(?=.*\d)(?=.*[a-z])(?=.*[A-Z])(?=.*[!@#$%^&amp;*_=+-])(?!.*\s).*$/,
                                }"
                                type="password"
                                placeholder="Create new password"
                                :class="{
                                    'is-invalid': errors.has('new password'),
                                }"
                                name="new password"
                            ></b-form-input>
                            <div
                                class="system-user-warning password-validation"
                            >
                                <i
                                    v-b-tooltip.hover
                                    class="icon-error_outline"
                                    title=" 
                                    - Password must be between 6-20 characters.
                                    - Password must contain at least 1 uppercase letter, 1 lowercase. letter, 1 numeric character and at least 1 symbol.
                                    - The symbols allowed are !@#$%^&amp;*_=+      
                                    - Last 10 passwords cannot be reused."
                                ></i>
                            </div>
                        </b-form-group>
                    </div>

                    <div class="col-md-12">
                        <b-form-group
                            id="confirm-password-input"
                            label="Confirm Password"
                            label-for="confirm-password"
                        >
                            <b-form-input
                                id="confirm-password-field"
                                v-model="formData.passwordConfirmation"
                                v-validate="{
                                    required: true,
                                    confirmed: 'password',
                                    max: 20,
                                    min: 6,
                                    regex: /^(?=^.{6,20}$)(?=.*\d)(?=.*[a-z])(?=.*[A-Z])(?=.*[!@#$%^&amp;*_=+-])(?!.*\s).*$/,
                                }"
                                type="password"
                                placeholder="Re-enter new password"
                                data-vv-name="password confirmation"
                                :class="{
                                    'is-invalid': errors.has(
                                        'password confirmation'
                                    ),
                                }"
                            ></b-form-input>
                        </b-form-group>
                    </div>
                </div>
                <div class="col-md-12 action-buttons">
                    <base-button
                        btn-label="Submit"
                        btn-type="submit"
                        btn-variant="primary"
                        :class="loading ? 'disabled' : ''"
                    ></base-button>
                    <base-button
                        btn-label="Cancel"
                        btn-type="reset"
                        :disabled="loading"
                        btn-variant="link"
                    ></base-button>
                </div>
            </b-form>
        </b-modal>
    </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
    // End of Component > data
    /*
    |--------------------------------------------------------------------------
    | Component > props
    |--------------------------------------------------------------------------
    */

    props: {
        showModalProp: {
            type: Boolean,
        },
    },
    /*
    |--------------------------------------------------------------------------
    | Component > data
    |--------------------------------------------------------------------------
    */
    data() {
        return {
            formData: this.initializeFormData(),
        }
    }, // End of Component > props

    /*
    |--------------------------------------------------------------------------
    | Component > watch
    |--------------------------------------------------------------------------
    */
    watch: {
        showModalProp(value) {
            if (value) {
                this.showModal()
            } else {
                this.hideModal()
            }
        },
        //hide Popup after success response
        hidePopup(value) {
            if (value) {
                this.hideModal()
            }
        },
    }, // End of Component > watch

    /*
    |--------------------------------------------------------------------------
    | Component > computed
    |--------------------------------------------------------------------------
    */
    computed: {
        ...mapGetters(['loading']),
    }, // End of Component > computed

    /*
    |--------------------------------------------------------------------------
    | Component > methods
    |--------------------------------------------------------------------------
    */
    methods: {
        showModal() {
            this.$refs.modal.show()
        }, // End of showModal() methods

        hideModal() {
            Object.assign(this.formData, this.initializeFormData())
            this.$emit('hide-modal')
            this.$refs.modal.hide()
            this.$validator.reset()
        }, // End of hideModal() methods

        initializeFormData() {
            return {
                oldPassword: '',
                password: '',
                passwordConfirmation: '',
            }
        }, // End of initializeFormData() methods

        async onSubmit() {
            const result = await this.$validator.validateAll()
            // let checkPassword = this.checkPassword(this.formData.password)
            if (result /*&& checkPassword*/) {
                try {
                    // authChangePassword action in auth store
                    let response = await this.$store.dispatch(
                        'authChangePassword',
                        this.formData
                    )
                    // Clearing formData fields and close popup on success response
                    if (response) {
                        this.clearFormData()
                        this.$refs.modal.hide()
                    }
                } catch (error) {
                    console.log(
                        error,
                        'There is an error on change submit password'
                    )
                }
            } else {
                let error = this.errors.all()[0]
                // if (!checkPassword && !error) {
                //     error =
                //         'The password must contain at least: 1 uppercase letter, 1 lowercase letter, 1 number, and one special character'
                // }
                this.$store.commit('setError', error)
            }
        }, // End of onSubmit() method

        clearFormData() {
            this.$validator.reset()
            Object.assign(this.formData, this.initializeFormData())
        }, // End of clearFormData() method
        // checkPassword(str) {
        //     // at least one number, one lowercase and one uppercase letter one special char
        //     // at least six characters
        //     var strongRegex = new RegExp(
        //         '/^(?=^.{6,20}$)(?=.*\d)(?=.*[a-z])(?=.*[A-Z])(?=.*[!@#$%^&amp;*_+-])(?!.*\s).*$/'
        //     )

        //     return strongRegex.test(str)
        // },
    }, // End of Component > methods
}
</script>
